import { Attribute } from "../../types/prodcatBaseTypes";

export function getAttributeValues(
  key: string,
  attributes: Attribute[],
): string[] {
  const attribute = attributes.find((attribute) => attribute.key === key);
  return attribute?.values ? [...attribute.values] : [];
}
